export const pe = {
  sodimac: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Haz tu mejor elección de $xlp_name$ $facet_value$ y encuentra las mejores marcas en Sodimac $country$',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra $facet_value$ en $xlp_name$, elige el modelo perfecto para ti y aprovecha nuestras ofertas en Sodimac $country$',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Conoce nuestro catálogo de $xlp_name$ y aprovecha nuestras ofertas. Entra a Sodimac $country$ y encuentra tus productos favoritos a precios increíbles',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p><p>Los productos de %Category Name% que necesitas para el mejoramiento de tu hogar están en Sodimac Perú a un precio increíble. Tenemos una gran variedad de opciones y modelos que se adecúan a cada uno de los espacios que desees renovar, ya sea la sala, comedor, dormitorio, oficina, cocina, baño, terraza, garaje o el que tengas en mente.</p><p>En nuestra categoría %Category Name% encontrarás modelos en diversos materiales, medidas, colores y demás características específicas de tu preferencia. Recuerda que solo en Sodimac Perú contamos con todo lo necesario para cada uno de tus proyectos en las mejores marcas de calidad y con garantía.</p><p><h2>Precios de %Category Name% en Sodimac Perú</h2> Si buscar ahorrar, estás en la tienda correcta porque en Sodimac tenemos nuestra política de precios bajos garantizados en %Category Name%, así que no dudes más y compra online este producto con sus complementos para que termines tu proyecto al 100% a un costo económico. Además, elige entre las opciones de delivery o recojo en tienda.</p><p><h2>Las mejores marcas de %Category Name%</h2> Sabemos que la calidad, confianza y seguridad son factores importantes al momento de decidir qué modelo comprar, por ello contamos con una amplia oferta de marcas prestigiosas y reconocidas en %Category Name%. De esta manera, inviertes en durabilidad, rendimiento, excelencia y satisfacción garantizada.</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Sodimac $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_BADGE: 'Este producto',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_RETRY: 'Actualizar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_MORE_OPTIONS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_IMAGE_SIMILAR_PRODUCT: 'Producto similar a la imagen principal',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      SHOP_THE_PROJECT_TOOLTIP_SIMILAR_PRODUCT_TEXT: 'Producto similar a la imagen principal.',
      SHOP_THE_PROJECT_TOOLTIP_BUTTON_TEXT: 'Más detalles',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_TITLE: 'Recrea el espacio',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_DESCRIPTION:
        'También puedes revisar el detalle de cada producto para recrear todo el espacio.',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_SKIP: 'Omitir',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_PRODUCT_NOT_LOADED: 'No se pudo cargar el producto',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_TRY_AGAIN_LATER: 'Intenta más tarde.',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1',
      FALLBACK_SEO_TITLE_TYPE: '',
      FALLBACK_SEO_DESCRIPTION_BRAND: '',
      FALLBACK_SEO_TITLE: '',
      FALLBACK_SEO_DESCRIPTION_TYPE: '',
      FALLBACK_SEO_TITLE_BRAND: '',
      FALLBACK_SEO_DESCRIPTION: '',
      BV_QUESTIONS_CATEGORIES_ALLOWED: '',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: false,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: true,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
      SHOW_SKELETON: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.pe/falabella-pe/page/devoluciones-y-cambios',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
      BAZAARVOICE_SCRIPT_URL:
        'https://apps.bazaarvoice.com/deployments/Falabella-PE/sodimac_standalone/production/es_PE/bv.js',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      CES_SEGMENT: {
        so_sope_plata: 'CES_PLATA',
        so_sope_oro: 'CES_ORO',
        so_sope_black: 'CES_BLACK',
      },
      TIME_OUT_SKELETON: 1000,
    },
  },
  tottus: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Encuentra $xlp_name$ $facet_value$ de excelente calidad a increíbles precios en Tottus $country$, aprovecha nuestras ofertas en tus marcas favoritas',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Conoce los modelos de $facet_value$ en $xlp_name$. Elige la opción perfecta y adquiere tus productos favoritos con descuentos en Tottus $country$.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Encuentra lo mejor en $xlp_name$ que tenemos para ti en Tottus $country$, aprovecha nuestros precios bajos y compra de manera fácil y segura.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p><p>Los productos de %Category Name% que necesitas para el mejoramiento de tu hogar están en Sodimac Perú a un precio increíble. Tenemos una gran variedad de opciones y modelos que se adecúan a cada uno de los espacios que desees renovar, ya sea la sala, comedor, dormitorio, oficina, cocina, baño, terraza, garaje o el que tengas en mente.</p><p>En nuestra categoría %Category Name% encontrarás modelos en diversos materiales, medidas, colores y demás características específicas de tu preferencia. Recuerda que solo en Sodimac Perú contamos con todo lo necesario para cada uno de tus proyectos en las mejores marcas de calidad y con garantía.</p><p><h2>Precios de %Category Name% en Sodimac Perú</h2> Si buscar ahorrar, estás en la tienda correcta porque en Sodimac tenemos nuestra política de precios bajos garantizados en %Category Name%, así que no dudes más y compra online este producto con sus complementos para que termines tu proyecto al 100% a un costo económico. Además, elige entre las opciones de delivery o recojo en tienda.</p><p><h2>Las mejores marcas de %Category Name%</h2> Sabemos que la calidad, confianza y seguridad son factores importantes al momento de decidir qué modelo comprar, por ello contamos con una amplia oferta de marcas prestigiosas y reconocidas en %Category Name%. De esta manera, inviertes en durabilidad, rendimiento, excelencia y satisfacción garantizada.</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ con ofertas increíbles',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Tottus $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1',
      FALLBACK_SEO_TITLE: '',
      FALLBACK_SEO_DESCRIPTION: '',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: false,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: false,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: true,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.pe/falabella-pe/page/devoluciones-y-cambios',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
    },
  },
  linio: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Encuentra $xlp_name$ $facet_value$ con descuentos impresionantes, haz la mejor elección para ti y conoce nuestras ofertas online.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Compra $facet_value$ en $xlp_name$ con grandes ofertas, realiza tus compras online con envíos seguros en Linio $country$.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Conoce nuestros precios en $xlp_name$ y adquiere de manera fácil y segura tus productos favoritos en Linio $country$',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p><p>Los productos de %Category Name% que necesitas para el mejoramiento de tu hogar están en Sodimac Perú a un precio increíble. Tenemos una gran variedad de opciones y modelos que se adecúan a cada uno de los espacios que desees renovar, ya sea la sala, comedor, dormitorio, oficina, cocina, baño, terraza, garaje o el que tengas en mente.</p><p>En nuestra categoría %Category Name% encontrarás modelos en diversos materiales, medidas, colores y demás características específicas de tu preferencia. Recuerda que solo en Sodimac Perú contamos con todo lo necesario para cada uno de tus proyectos en las mejores marcas de calidad y con garantía.</p><p><h2>Precios de %Category Name% en Sodimac Perú</h2> Si buscar ahorrar, estás en la tienda correcta porque en Sodimac tenemos nuestra política de precios bajos garantizados en %Category Name%, así que no dudes más y compra online este producto con sus complementos para que termines tu proyecto al 100% a un costo económico. Además, elige entre las opciones de delivery o recojo en tienda.</p><p><h2>Las mejores marcas de %Category Name%</h2> Sabemos que la calidad, confianza y seguridad son factores importantes al momento de decidir qué modelo comprar, por ello contamos con una amplia oferta de marcas prestigiosas y reconocidas en %Category Name%. De esta manera, inviertes en durabilidad, rendimiento, excelencia y satisfacción garantizada.</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Linio $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1',
      FALLBACK_SEO_TITLE: '',
      FALLBACK_SEO_DESCRIPTION: '',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: true,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.pe/falabella-pe/page/devoluciones-y-cambios',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
    },
  },
  marketplace: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Conoce nuestro catálogo de $xlp_name$ $facet_value$ y compra online de forma fácil y segura en Saga Falabella. Aprovecha nuestras ofertas en tus productos favoritos.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra $facet_value$ en $xlp_name$a precios increíbles, realiza tus compras online de manera segura en Saga Falabella.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        '$xlp_name$ de las mejores marcas a un clic, encuentra tu modelo favorito a un precio inigualable. ¡No te pierdas las ofertas de Saga Falabella!',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p><p>Los productos de %Category Name% que necesitas para el mejoramiento de tu hogar están en Sodimac Perú a un precio increíble. Tenemos una gran variedad de opciones y modelos que se adecúan a cada uno de los espacios que desees renovar, ya sea la sala, comedor, dormitorio, oficina, cocina, baño, terraza, garaje o el que tengas en mente.</p><p>En nuestra categoría %Category Name% encontrarás modelos en diversos materiales, medidas, colores y demás características específicas de tu preferencia. Recuerda que solo en Sodimac Perú contamos con todo lo necesario para cada uno de tus proyectos en las mejores marcas de calidad y con garantía.</p><p><h2>Precios de %Category Name% en Sodimac Perú</h2> Si buscar ahorrar, estás en la tienda correcta porque en Sodimac tenemos nuestra política de precios bajos garantizados en %Category Name%, así que no dudes más y compra online este producto con sus complementos para que termines tu proyecto al 100% a un costo económico. Además, elige entre las opciones de delivery o recojo en tienda.</p><p><h2>Las mejores marcas de %Category Name%</h2> Sabemos que la calidad, confianza y seguridad son factores importantes al momento de decidir qué modelo comprar, por ello contamos con una amplia oferta de marcas prestigiosas y reconocidas en %Category Name%. De esta manera, inviertes en durabilidad, rendimiento, excelencia y satisfacción garantizada.</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ y más',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Saga Falabella. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1',
      FALLBACK_SEO_TITLE: '',
      FALLBACK_SEO_DESCRIPTION: '',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: true,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.pe/falabella-pe/page/devoluciones-y-cambios',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
    },
  },
  homecenter: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en falabella.com Conoce nuestro catálogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra $facet_value$ en $xlp_name$ a precios increíbles, realiza tus compras online de manera segura en falabella.com',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Encuentra $xlp_name$ de las mejores marcas en falabella.com, conoce la variedad de $xlp_name$ y elige el precio ideal para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p><p>Los productos de %Category Name% que necesitas para el mejoramiento de tu hogar están en Sodimac Perú a un precio increíble. Tenemos una gran variedad de opciones y modelos que se adecúan a cada uno de los espacios que desees renovar, ya sea la sala, comedor, dormitorio, oficina, cocina, baño, terraza, garaje o el que tengas en mente.</p><p>En nuestra categoría %Category Name% encontrarás modelos en diversos materiales, medidas, colores y demás características específicas de tu preferencia. Recuerda que solo en Sodimac Perú contamos con todo lo necesario para cada uno de tus proyectos en las mejores marcas de calidad y con garantía.</p><p><h2>Precios de %Category Name% en Sodimac Perú</h2> Si buscar ahorrar, estás en la tienda correcta porque en Sodimac tenemos nuestra política de precios bajos garantizados en %Category Name%, así que no dudes más y compra online este producto con sus complementos para que termines tu proyecto al 100% a un costo económico. Además, elige entre las opciones de delivery o recojo en tienda.</p><p><h2>Las mejores marcas de %Category Name%</h2> Sabemos que la calidad, confianza y seguridad son factores importantes al momento de decidir qué modelo comprar, por ello contamos con una amplia oferta de marcas prestigiosas y reconocidas en %Category Name%. De esta manera, inviertes en durabilidad, rendimiento, excelencia y satisfacción garantizada.</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ grandes ofertas',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: true,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com.pe/falabella-pe/page/devoluciones-y-cambios',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
    },
  },
  so_com: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '18:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en falabella.com Conoce nuestro catálogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra $facet_value$ en $xlp_name$ a precios increíbles, realiza tus compras online de manera segura en falabella.com',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Encuentra $xlp_name$ de las mejores marcas en falabella.com, conoce la variedad de $xlp_name$ y elige el precio ideal para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p><p>Los productos de %Category Name% que necesitas para el mejoramiento de tu hogar están en Sodimac Perú a un precio increíble. Tenemos una gran variedad de opciones y modelos que se adecúan a cada uno de los espacios que desees renovar, ya sea la sala, comedor, dormitorio, oficina, cocina, baño, terraza, garaje o el que tengas en mente.</p><p>En nuestra categoría %Category Name% encontrarás modelos en diversos materiales, medidas, colores y demás características específicas de tu preferencia. Recuerda que solo en Sodimac Perú contamos con todo lo necesario para cada uno de tus proyectos en las mejores marcas de calidad y con garantía.</p><p><h2>Precios de %Category Name% en Sodimac Perú</h2> Si buscar ahorrar, estás en la tienda correcta porque en Sodimac tenemos nuestra política de precios bajos garantizados en %Category Name%, así que no dudes más y compra online este producto con sus complementos para que termines tu proyecto al 100% a un costo económico. Además, elige entre las opciones de delivery o recojo en tienda.</p><p><h2>Las mejores marcas de %Category Name%</h2> Sabemos que la calidad, confianza y seguridad son factores importantes al momento de decidir qué modelo comprar, por ello contamos con una amplia oferta de marcas prestigiosas y reconocidas en %Category Name%. De esta manera, inviertes en durabilidad, rendimiento, excelencia y satisfacción garantizada.</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ grandes ofertas',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Comprar $xlp_name$ en sodimac.com.pe. Elige productos para hogar y proyectos de las mejores marcas y al mejor precio en Sodimac - Homecenter.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Comprar $xlp_name$ en sodimac.com.pe. Elige productos para hogar y proyectos de las mejores marcas y al mejor precio en Sodimac - Homecenter.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_BADGE: 'Este producto',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_RETRY: 'Actualizar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_MORE_OPTIONS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_IMAGE_SIMILAR_PRODUCT: 'Producto similar a la imagen principal',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      SHOP_THE_PROJECT_TOOLTIP_SIMILAR_PRODUCT_TEXT: 'Producto similar a la imagen principal.',
      SHOP_THE_PROJECT_TOOLTIP_BUTTON_TEXT: 'Más detalles',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_TITLE: 'Recrea el espacio',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_DESCRIPTION:
        'También puedes revisar el detalle de cada producto para recrear todo el espacio.',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_SKIP: 'Omitir',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_PRODUCT_NOT_LOADED: 'No se pudo cargar el producto',
      SHOP_THE_PROJECT_AMBIENT_IMAGE_TRY_AGAIN_LATER: 'Intenta más tarde.',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1,,PDP-BT-1',
      DRIVER_BADGE_LABEL: 'Estás viendo',
      PDP_SLOTS_SOCOM: 'PDP-CMP-1',
      BV_QUESTIONS_CATEGORIES_ALLOWED: '',
    },
    toggles: {
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: true,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: true,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: false,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: false,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: true,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: true,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
      hideOtherStoreFacets: true,
      SHOW_SKELETON: true,
      isBuyTogetherEnabled: true,
      isShopTheProjectEnabled: true,
      showDriverInComparativeTable: true,
      showComparativeTable: true,
      showRecommendedProducts: true,
      isShopTheProjectAmbientImageEnabled: true,
      isShopTheProjectAmbientImageCoachmarkEnabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.sodimac.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
      BAZAARVOICE_SCRIPT_URL:
        'https://apps.bazaarvoice.com/deployments/Falabella-PE/sodimac_standalone/production/es_PE/bv.js',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: true,
        labels: true,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      CES_SEGMENT: {
        so_sope_plata: 'CES_PLATA',
        so_sope_oro: 'CES_ORO',
        so_sope_black: 'CES_BLACK',
      },
      TIME_OUT_SKELETON: 1000,
      allowedStoreFacetOperators: ['sodimac', 'homecenter', 'maestro'],
      driverBadgeConfig: {
        type: 'DRIVER_BADGE',
        backgroundColor: '#717171',
        textColor: '#ffffff',
      },
      shopTheProjectConfig: {
        channel: 'beta',
      },
    },
  },
  to_com: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      'AZUL CLARO': '#94bfdc',
      ROJO: '#ba2d1e',
      NEGRO: '#000000',
      BEIGE: '#cfb174',
      CELESTE: '#94bfdc',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      VERDE: '#519548',
      MORADO: '#6d165a',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      FALLBACK_IMAGES_DOMAIN: 'https://media.falabella.com',
      HOME_DELI_AVAILABLE_RESULT: 'Disponibilidad de fechas y horarios:',
      CMRAPERTURATEXT_SAVE: 'Ahorra',
      STORES_WITH_STOCK_IN_OTHER_COMUNA: 'tiendas con stock en otros distritos',
      ENVIO_GRATIS_LABEL_AMOUNT: 'S/ 99',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      RETURN_POLICY_PARA_1_2:
        'Sin embargo, tenemos categorías que cuentan con plazos diferentes, otras con restricciones y algunas que no se pueden devolver ni cambiar. Conoce cuáles son:',
      RETURN_POLICY_PARA_1_1:
        'La mayoría de los productos tienen <b style="font-weight: bold">30 días desde que los recibes para hacer una devolución.</b>',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      ADDING_TO_CART_1: 'Agregando',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL:
        'https://api-falabella-connect.buffetcloud.io/test/credito/bff/web/solicita/llamada',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      ACCUMULATE: 'Acumula hasta',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'AGREGAR AL CARRO',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Excelente cuando se compran juntos',
      REGIONS: 'Regiones',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      INTERNATIONAL_SHIPPING_BULLETS:
        'El vendedor envíe tu producto desde el país de origen.*Tu producto llegue a Perú.*Tu producto esté en camino a tu domicilio.',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Despacho a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$ conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      RETURN_POLICY_INFO_SOFTLINE: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      SELLER_SKU_ID: 'Cód. tienda',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      SEE_COMMENTS: 'Ver más comentarios',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE CÉDULA DE IDENTIDAD',
      MORE_PRODUCTS_FROM_COLLECTION: 'Más productos de esta colección',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona una tienda',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en falabella.com Conoce nuestro catálogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra $facet_value$ en $xlp_name$ a precios increíbles, realiza tus compras online de manera segura en falabella.com',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      PRODUCT_OUTOFSTOCK: 'Producto sin stock :(',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce nuestra Satisfacción garantizada',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_PRICE_LABEL: 'Precio',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Distrito',
      LOG_OUT_LABEL: 'Cerrar sesión',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      READY: 'Aplicar',
      SLP_BI_AB_COOKIE: 'search_ab',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos de tu carro de compras pueden agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Departamento',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      RETURN_POLICY_MODAL_FOOTER: 'Conoce más sobre',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      PLANES: 'PLANES',
      CMRAPERTURATEXT_USING_CMR: 'con tu CMR',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_LIGHT: '',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      sellerMuteValue: 'LINIO',
      FAILED_ADDING_TO_CART_WARRANTY:
        'En este momento no podemos agregar la opción de Garantía extendida. Por favor inténtalo nuevamente más tarde.',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis',
      FAILED_ADDING_TO_CART_LABEL: '¡Qué mal! Justo se agotó el producto. Busca otros similares.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      MY_ACCOUNT: 'Mis ordenes',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      HOME_DELIVERY_SHIPPING: 'Despacho a Domicilio',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      ENVIO_GRATIS_LABEL: 'En productos pequeños desde',
      FREE_SHIPPING_PRICE_3P: '99',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      INTERNATIONAL_SHIPPING_BULLET_TITLE: 'Notificaciones importantes',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      ASSOCIATED_SELLER_INFO:
        'Este producto es propiedad de un vendedor asociado y distribuido por Falabella. Si quieres vender en el portal de Falabella, entra a {MARKETPLACE_URL}, regístrate y publica tus productos.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      RETURN_POLICY_INFO_HARDLINE: 'Para cambios o devoluciones.',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        'Este producto está publicado directamente por un vendedor nacional y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.',
      REQUEST_PRODUCT: 'Solicitar Producto',
      LOGIN_OR: 'ó',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      G_CATEGORIES_TO_HIDE_RETURN_POLICY: 'G080207,G080209',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante la compra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Tiendas disponibles',
      CMSIZE: 'cm',
      OF: 'de',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Encuentra $xlp_name$ de las mejores marcas en falabella.com, conoce la variedad de $xlp_name$ y elige el precio ideal para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      CLEAN: 'Limpiar Filtro',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en trastienda',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT: '',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Conoce los productos de $xlp_name$. Entra y aprovecha los precios que tenemos en tus productos favoritos. Encuéntralos en falabella.com',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      SHARE_FIND_IN: 'Encuéntralo en',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: 'Pídela y ahorra más de s/100 en Falabella',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      RATINGS_STAR_MORE_TEXT: 'y más',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y ahorra más de s/100 en Falabella',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Pídela y ahorra más de s/100 en Falabella',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      EVALUATE_PLANS_BUTTON: 'EVALUAR PLANES PARA MÍ',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RETURN_POLICY_HEADING: 'Devolver es fácil y gratis',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Descripción',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(condiciones y coberturas)',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      FREE_SHIPPING_SIZES: 'xxs,XXS,xs,XS,xs2,XS2,xs3,XS3',
      LOGIN_SIGN_UP: 'Regístrate',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ grandes ofertas',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'QUIERO EVALUARME',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt6f6768aa7435c266/Productos-Reacondicionados-Peru.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      UKSIZE: 'UK',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      NEXT: 'Siguiente',
      VENDOR_STOCK_LABEL: 'Stock',
      CIUDAD: 'Provincia',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores quetenemos para ti con este teléfono.',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      TRACK_ORDER: 'Seguimiento de mi orden',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      BOOM_SHIPPING: 'Boom',
      PRODUCT_CODE: 'Código',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 2 2390 6534',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN:
        'https://api-falabella-connect.buffetcloud.io/test/autentia/bff/web/getToken',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'AGREGAR LOS {count} A LA BOLSA',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      PICKUP_INSTORE_TITLE: 'Retira tu compra',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '16:00 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      WARNING_A11Y_LABEL: 'Warning',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'DEBES EVALUARTE',
      RETURN_POLICY_PARA_4_1:
        '<b style="font-weight: bold">No tienen devolución o cambio si te arrepientes de la compra</b>',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      INTERNATIONAL_SHIPPING_BULLETS_1:
        'Podrás realizar un máximo de 3 importaciones al año con tu DNI, recuerda que debes tener más de 18 años. A partir de la cuarta compra podrás gestionar la importación con tu RUC.*Estos productos no se pueden devolver por cambio de parecer. Pero no te preocupes que de presentarse alguna falla de fábrica o recibir un producto erróneo, podrás solicitar la revisión técnica y te confirmaremos si aplica la devolución.*El precio publicado incluye el envío internacional y los impuestos de aduanas.*La ley General de Aduanas(art 197) exige que los datos del titular de la compra se registren tal cual figuran en el DNI (todos los nombres y ambos apellidos). En caso se detecte una diferencia, se aplicará una multa por la rectificación la que tiene un costo de 0.1 UIT (S/ 535.00), los que tendrán que ser asumidos por el cliente. Por favor, verifica bien tus datos antes de hacer la compra.',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      CIUDAD_TEXT: 'Provincia',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'devoluciones y cambios',
      CMRAPERTURATEXT_REQUEST: '¡Compra con tu CMR Visa y acumula CMR Puntos!',
      CMR_POINTS: 'CMR Puntos',
      HOME_SHIPPING: 'Envío a domicilio',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      RETURN_POLICY_PARA_3_1: '<b style="font-weight: bold">Deben estar cerrados, con todos sus sellos y etiquetas</b>',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      RETURN_POLICY_LIST_2:
        '<b style="font-weight: bold">48 horas</b>: cemento, mezclas de: hormigón, morteros, yeso y otros productos para asfalto, hormigón, albañilería.*<b style="font-weight: bold">7 días</b>: electrodomésticos, tecnología, línea blanca, colchones, muebles, bicicletas y máquinas de ejercicio.',
      PUM_AFFIX: ' a ',
      RETURN_POLICY_LIST_4:
        'Productos de compra internacional.*Alimentos y bebidas. ​*Productos digitales (descarga inmediata).​​​*De segunda mano o reacondicionados.​​​*Productos hechos a medida.​​​*Pinturas color a pedido.​​​*Medicamentos, vitaminas y suplementos.​​​*Plantas​​.*Productos que hayan sido previamente instalados.*Baterías de auto.',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      RETURN_POLICY_LIST_3:
        'Cuidado personal, belleza, higiene y salud, productos de bienestar sexual.​​*Trajes de baño, fajas, ropa interior.​​​*Electrónica.​​​*Electro hogar.​​*Almohadas y ropa de cama.​*Muebles armables y pinturas.​​​*Alimentos y cuidado de mascotas.​​​*Productos de limpieza (PGC no comestible).​*Asiento de inodoro.*Toallas de baño y playa.',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      ACCEPT: 'ACEPTAR',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '18',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      SELLER_NAMES_EXCLUDED_FOR_FREE_SHIPPING: 'falabella, tottus, sodimac, linio',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 2 2390 6534',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_PARA_2_1: '<b style="font-weight: bold">Otros plazos para devolución y cambio</b>',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      INTERNATIONAL_SHIPPING_PARA_1_DESC_BOLD: '',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      FREE_SHIPPING_PRICE: '99',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      RETURN_POLICY_MODAL_HEADER_1: 'Satisfacción garantizada',
      INTERNATIONAL_SHIPPING_FOOTER: 'Para más información, revisa nuestro',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto a la bolsa',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      WARRANTY_LABEL_PREFIX: '',
      PDP_NO_THANKS: 'Sin garantía extendida',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com. Aprovecha las ofertas de $xlp_name$ y elige la opción perfecta para ti.',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b>,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      darSectionLabel: 'Producto sin derecho a retracto',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio',
      WHOLESALE_BANNER_BADGE_TEXT_2: 'Volumen',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      PDP_SLOTS: 'PDP-HRT-1',
      MY_FAV_TAG_NAME: 'Mis Favoritos',
      RESTRICTED_VARIANT_MODAL_TEXT:
        "Para comprar este producto debes ser <b style='font-weight: bold'>mayor de 18 años.</b> Además te recordamos que, cuando recibas tu pedido, debes mostrar tu cédula de identidad u otro documento expendido por la autoridad pública que acredite tu edad.</b>",
    },
    toggles: {
      isSellerInfoVisibleInPDP: false,
      isHomeDeliveryVisibleInPod: true,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isShippingFacetsWithZonesVisible: false,
      isShippingLabels404LogsDisabled: false,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: false,
      isRedirect301EnabledForPLP: true,
      isGenericCalculatorEnabled: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: true,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: true,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isRelatedKeywordEnabled: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: true,
      areSponsoredClickEventsEnabledWithQueryParams: false,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isHomeDeliveryVisibleInPDP: true,
      isPopOverVisible: true,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      isActiveTabAssistentePersonal: false,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isSisSodimacPdpEnabled: false,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: true,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: true,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isSellerBusinessNameEnabled: true,
      isVwoEnabled: 'true',
      isShippingFacetsWithFlattenedPAIVisible: false,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":true,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: false,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: true,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: true,
      isWarrantyAtProductLevel: true,
      isBreadcrumbsV1Enabled: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      isInternationalBuyVisiblePDP: true,
      disableSponsoredProductsSisPDP: false,
      isMeatStickerApplicable: true,
      isBoomVisibleInFacet: false,
      is3PFreeShippingEnabled: false,
      isQuantitySelectorVisibleInPDP: true,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: true,
      isShippingLabelsEnabledInXlp: true,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isShippingLabelsEnabledInPdp: false,
      isCMRAperturaEnabled: false,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isAddtionalSellerTextEnabled: true,
      isCartQuantityLimitsEnabled: false,
      isPurchaseOnlineVisibleInPDP: false,
      freeShippingOnZonesEnabled: true,
      isNewSortingLogicForSponsoredProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isNewPriceApplicable: true,
      isRedirect301EnabledForCollection: false,
      isRelevancyForCollection: true,
      searchWithPoliticalAreaIdEnabled: false,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: false,
      isNewWarrantyUIEnabled: true,
      isNormalPriceCrossedOut: true,
      isNewWarrantyOptionsEnabled: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: false,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isEventToggleVisible_SO_COM: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: false,
      isPositionPerCategoryEnabled: true,
      isDemoUpVideoEnabled: false,
      isEnabledSponsoredClickInPDP: true,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isImageGalleryEnabled: false,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: false,
      isDynamicFacetsEnabled: true,
      showRatingDescription: false,
      SHOW_SPONSORED_STRIP: true,
      isImprovedWarrantyUiEnabled: true,
      isImprovedServicesUiEnabled: true,
      newFreeShippingEnabled: false,
      enableSponsoredInRecommendation: true,
      isNewOmniChannelExperience: true,
      isEventToggleVisible_TO_COM: true,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isInstallmentWithoutInterestEnabled: false,
      isOkToShopFeatureEnabled: true,
      isRatingsShownInPDP: false,
      isOneClickCheckoutEnabled: false,
      isCartPersistanceEnabled: true,
      isReviewsShownInPDP: false,
      isTottusBrandFilterDisabled: false,
      getBrandNameFromVariantLevelTocom: true,
      isEnabledAddToCartInReco: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?detalleClic=pdpconou',
      SERVICES_PE_FALABELLA: '',
      SERVICES_PE_SODIMAC: 'https://sodimac.falabella.com.pe/sodimac-pe/page/servicios-hogar',
      CATALYST_AUTH_BASEURL: 'https://www.tottus.com.pe',
      ATG_AUTH_BASEURL: 'https://www.falabella.com.pe',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com.pe/falabella-pe/myaccount/myLists',
      SO_COM_RETURN_POLICY_LINK_URL: 'https://www.sodimac.com.pe/sodimac-pe/content/devoluciones-y-cambios',
      BASKET_PAGE_URI: 'https://www.tottus.com.pe/tottus-pe/basket',
      SO_COM_SERVICES_PE_SODIMAC: '',
      RETURN_POLICY_LINK_URL: 'https://www.tottus.com.pe/tottus-pe/content/terminos-y-condiciones',
      SERVICES_PE_TOTTUS: '',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.com.pe/sodimac-pe/basket',
      APERTURA_URL_INVALID_CMR: 'https://www.falabella.com.pe/falabella-pe/page/CMR-enlinea?=&detalleClic=pdpsinou',
      INTERNATIONAL_SHIPPING_LINK: 'https://www.falabella.com.pe/falabella-pe/page/compra-internacional',
      moreWarrantyBenefitsLink: '',
    },
    facetLabels: {
      'f.derived.variant.freeShipping': '<p>En productos pequeños desde&nbsp;<strong>S/ 99</strong></p>',
      'f.derived.variant.activeEvent': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>Lo mejor de CYBER WOW</p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>ASEO FEST</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: true,
          labels: true,
        },
        default: {
          facets: true,
          labels: true,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 4,
            mobile: 10,
            tablet: 10,
          },
          search: {
            desktop: 12,
            mobile: 14,
          },
          cat2069: {
            desktop: 12,
            mobile: 14,
          },
          cat3112: {
            desktop: 12,
            mobile: 14,
          },
          cat7660002: {
            desktop: 12,
            mobile: 14,
          },
          cat690199: {
            desktop: 12,
            mobile: 14,
          },
          cat3214: {
            desktop: 12,
            mobile: 14,
          },
          cat40052: {
            desktop: 12,
            mobile: 14,
          },
          cat70057: {
            desktop: 12,
            mobile: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1671544221138-0',
            folder: '/21632469435/fape_plp_banner_superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1671544091827-0',
            folder: '/21632469435/fape_plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-0',
            folder: '/21632469435/fape_plp_horizontal_1',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com.pe/falabella-pe',
        sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
        tottus: 'https://tottus.falabella.com.pe/tottus-pe',
        linio: 'https://linio.falabella.com.pe/linio-pe',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: false,
        details: false,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusions: ['dior'],
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      skipPositionCategories: [
        'cat4100462',
        'CATG35030',
        'CATG34996',
        'cat4100470',
        'cat4100477',
        'cat4100471',
        'cat4100474',
        'cat4100467',
        'cat4100476',
        'CATG34997',
        'cat1470526',
        'cat1470534',
        'cat16200461',
        'cat1470538',
        'cat1480500',
        'CATG15651',
        'cat1470548',
        'cat4100481',
        'cat4100482',
        'cat4100483',
        'cat13870465',
        'cat4100487',
        'cat4100489',
        'cat13910467',
        'cat7720465',
        'cat7720464',
        'cat6630630',
        'cat6630651',
        'cat6630648',
        'cat14410475',
        'CATG33665',
        'cat14410474',
        'cat6630649',
        'cat6630650',
        'cat6630655',
        'cat6630671',
        'cat14410472',
        'cat6630674',
        'cat14410471',
        'cat6630672',
        'cat14410473',
        'cat15840469',
        'CATG15268',
        'cat11030464',
        'CATG14569',
        'cat6630620',
        'cat560922',
        'cat4710461',
        'cat520470',
        'cat520466',
        'cat14340461',
        'cat520472',
        'cat520468',
        'cat6630576',
        'cat14370476',
        'cat14370472',
        'cat14370471',
        'cat14370473',
        'CATG15272',
        'CATG15814',
        'CAT550500',
        'CATG14546',
        'cat6880494',
        'CATG14547',
        'cat40500',
        'cat580482',
        'cat50676',
        'cat40710',
        'cat14460462',
        'cat6630567',
        'cat50675',
        'CATG15274',
        'cat3930550',
        'cat14400469',
        'cat14400471',
        'CATG33554',
        'cat11830505',
        'cat7730478',
        'cat6630601',
        'cat40611',
        'CATG14561',
        'CATG33555',
        'cat12490467',
        'cat6700466',
        'cat7350564',
        'cat7350588',
        'cat7350589',
        'cat14620485',
        'cat14620479',
        'cat7350592',
        'cat7350591',
        'cat7350593',
        'cat7350590',
        'cat7350594',
        'cat16640467',
        'cat7350562',
        'cat7350567',
        'cat14620481',
        'cat14620478',
        'cat7350570',
        'cat7350569',
        'cat7350571',
        'cat7350568',
        'cat7350572',
        'cat16640467',
        'CATG15485',
        'CATG15759',
        'CATG15760',
        'CATG15764',
        'CATG15762',
        'CATG15770',
        'CATG15763',
        'CATG15767',
        'CATG15765',
        'CATG15766',
        'CATG15757',
        'cat6630547',
        'CATG15486',
        'CATG15775',
        'CATG15776',
        'CATG15779',
        'CATG15777',
        'CATG15785',
        'CATG15778',
        'CATG15783',
        'CATG15780',
        'CATG15781',
        'CATG15774',
        'CATG15787',
      ],
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b>',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira hoy',
          cc_next_day: 'Retira mañana',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: '30 días para cambios y devoluciones',
            softline: 'Ten en cuenta nuestra',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Devolver es fácil y gratis',
          },
          info: {
            default: 'Para cambios o devoluciones.',
            shoes: 'Para cambios o devoluciones gratis en cualquier tienda Falabella.',
            softline: 'Para cambios o devoluciones gratis en cualquier tienda Falabella',
          },
          link: 'Conoce nuestra Satisfacción garantizada',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      TO_COM_DEFAULT_COORDS: {
        latitude: '-12.08074',
        longitude: '-77.09094',
      },
      rootCategoryId: 'CATG16049',
      discountThresholdForTottusPromotions: 5,
      enableTottusPromotionsBadges: false,
      enableTottusPromotionsCmrPrices: false,
    },
  },
};
